<user-detail-edit [backTo]="backTo" [userId]="userId"></user-detail-edit>
